import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import { Students } from '../../../constants';

const AssignToCoursePage = () => {
  return (
    <>
      <Breadcrumbs mainTitle={'Assign user to course'} parent={Students} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              {/* <CommonCardHeader title={StudentsListCardTitle} tag /> */}
              <CardBody></CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AssignToCoursePage;
